export interface HeldKeyRepeatState {
  heldMs: number;
  repeatsEmitted: number;
}

export interface HeldKeyRepeatInput {
  isDown: boolean;
  justDown: boolean;
  deltaMs: number;
}

export const HELD_KEY_REPEAT_DELAY_MS = 300;
export const HELD_KEY_REPEAT_INTERVAL_MS = 120;

export function createHeldKeyRepeatState(): HeldKeyRepeatState {
  return { heldMs: 0, repeatsEmitted: 0 };
}

export function advanceHeldKeyRepeat(
  state: HeldKeyRepeatState,
  input: HeldKeyRepeatInput,
): { state: HeldKeyRepeatState; steps: number } {
  if (!input.isDown) return { state: createHeldKeyRepeatState(), steps: 0 };
  if (input.justDown) return { state: createHeldKeyRepeatState(), steps: 1 };

  const deltaMs = Number.isFinite(input.deltaMs) ? Math.max(0, input.deltaMs) : 0;
  const heldMs = state.heldMs + deltaMs;
  const targetRepeats = heldMs < HELD_KEY_REPEAT_DELAY_MS
    ? 0
    : Math.floor((heldMs - HELD_KEY_REPEAT_DELAY_MS) / HELD_KEY_REPEAT_INTERVAL_MS) + 1;
  return {
    state: { heldMs, repeatsEmitted: targetRepeats },
    steps: Math.max(0, targetRepeats - state.repeatsEmitted),
  };
}
